import { render, staticRenderFns } from "./c_comb_data.vue?vue&type=template&id=0fabc054&scoped=true"
import script from "./c_comb_data.vue?vue&type=script&lang=js"
export * from "./c_comb_data.vue?vue&type=script&lang=js"
import style0 from "./c_comb_data.vue?vue&type=style&index=0&id=0fabc054&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabc054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fabc054')) {
      api.createRecord('0fabc054', component.options)
    } else {
      api.reload('0fabc054', component.options)
    }
    module.hot.accept("./c_comb_data.vue?vue&type=template&id=0fabc054&scoped=true", function () {
      api.rerender('0fabc054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_comb_data.vue"
export default component.exports